import { Box, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "@store/store";
import { useTheme } from "@mui/material";

export const CustomCompanyName = () => {
  const theme = useTheme();
  const companyData = useSelector((state: RootState) => state.register.company);

  return (
    <Box textAlign={"center"} mt={2} mb={2} display={"flex"} flexDirection={"column"} alignItems={"center"} gap={1}>
      <Typography fontSize={"22px"} fontWeight={600} color={theme?.palette?.primary?.dark}>
        Expediente digital
      </Typography>

      <Typography fontSize={"18px"} fontWeight={600} color={theme?.palette?.primary?.dark}>
        {companyData?.legal_name || "Razón social"}
      </Typography>
    </Box>
  );
};
